import { fetchTeleopViews } from "./api/teleopViews";

export class Views {
  static fetchTeleopViews = fetchTeleopViews;
}
